export default "__VITE_ASSET__AZZieG7w__"